angular.module('impactx.productlabel').directive('ixMissingProductLabelIcon', function () {
    return {
        restrict: 'A',
        link: function (scope, element) {
            element.bind('error', function () {
                element.replaceWith("<span class='mdi mdi-help-rhombus-outline'></span>");
            });
        }
    }
});